import { render, staticRenderFns } from "./PanelsQuestionsRules.vue?vue&type=template&id=70c9a971&scoped=true&"
import script from "./PanelsQuestionsRules.vue?vue&type=script&lang=js&"
export * from "./PanelsQuestionsRules.vue?vue&type=script&lang=js&"
import style0 from "./PanelsQuestionsRules.vue?vue&type=style&index=0&id=70c9a971&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c9a971",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
